import React, { useState } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Label, Icon } from '../KeyComponents';

function TextInputCopy(props) {
  const {
    label, state, placeholder, value, size, required
  } = props;
  const [inputValue, setInputValue] = useState(value);

  const copyClipboardFunction = () => {
    if (state === 'disabled') {
      return;
    }
    navigator.clipboard.writeText(inputValue);
  };

  const handleKeyPress = (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      copyClipboardFunction();
    }
  };

  return (
    <div className={classNames('pgn__text-input-r-wrapper', { 'pgn__text-input-r-wrapper-filled': inputValue !== '' }, `pgn__text-input-r-wrapper-${size}`, `pgn__text-input-r-wrapper-${state}`)}>
      {label && <Label label={label} required={required} />}
      <div className="pgn__text-input-r-body">
        <div className="pgn__text-input-r-body-left" />

        <input className="pgn__text-input-field" placeholder={placeholder} value={inputValue} onChange={(e) => setInputValue(e.target.value)} disabled={state === 'disabled'} />

        <div className="pgn__text-input-r-body-right" role="button" tabIndex={0} onClick={copyClipboardFunction} onKeyPress={handleKeyPress}>
          <Icon className="pgn__text-input-r-body-right-icon" icon="file-copy" type="line" />
        </div>
      </div>
    </div>
  );
}

TextInputCopy.defaultProps = {
  size: 'md',
  state: 'default',
  label: '',
  required: false,
  placeholder: 'Enter text here',
  value: ''
};

TextInputCopy.propTypes = {
  size: PropTypes.oneOf(['xs', 'sm', 'md']),
  state: PropTypes.oneOf(['default', 'error', 'disabled']),
  label: PropTypes.string,
  required: PropTypes.bool,
  placeholder: PropTypes.string,
  value: PropTypes.string
};

export default TextInputCopy;
